 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app~52817945": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app~52817945": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"stencil-polyfills-css-shim~2f793e75":"stencil-polyfills-css-shim~2f793e75","stencil-polyfills-dom~78119a74":"stencil-polyfills-dom~78119a74"}[chunkId]||chunkId) + "." + {"chunk-06f92ac4":"0974cbda","chunk-09407743":"be4c6559","chunk-0d8f1b98":"a3623f9a","chunk-0f261a1e":"c36c8598","chunk-14a192cf":"9ccdf926","chunk-24573624":"f80b8b43","chunk-2d0ac931":"17cfa0f8","chunk-2d0b8b30":"04199e63","chunk-2d0be2dc":"9aca2e62","chunk-2d0c0644":"c008a242","chunk-2d0c211b":"ba545cf5","chunk-2d0c4aa3":"f045d4dc","chunk-2d0c8871":"93488dd8","chunk-2d0ceeba":"39923f95","chunk-2d0cf315":"1ef6206f","chunk-2d0d3c84":"16079ac2","chunk-2d0d6d65":"331e3bb5","chunk-2d0d7863":"94cd3de2","chunk-2d0d78b2":"8e02befe","chunk-2d0e9381":"29d683ac","chunk-2d0e9b48":"6645483e","chunk-2d0f0b83":"06bef998","chunk-2d2080c7":"eebd2601","chunk-2d217def":"b35cd03e","chunk-2d21a9aa":"6003d65f","chunk-2d21d677":"9b0ed352","chunk-2d21e70e":"30ed3698","chunk-2d221f74":"3d4e6a0f","chunk-2d222cca":"2219326e","chunk-2d2248a4":"255feded","chunk-2d224c2b":"29f8cb1d","chunk-2d22895d":"ca2e81cc","chunk-2d2304d2":"f46cf096","chunk-2d23721e":"db20ec86","chunk-383ab6b7":"1171b25f","chunk-3a332b10":"b8be399a","chunk-4a0edd2d":"0b602b0d","chunk-50d2440c":"df92a232","chunk-538ff868":"6b566589","chunk-5ad11dd9":"3a53fec3","chunk-62f92ab4":"3f30510f","chunk-66eb9fb7":"2d73b454","chunk-6ac3eb20":"fd07ed3e","chunk-79479038":"6435bd1a","chunk-79db9216":"8bd729bd","chunk-7aa6f11c":"ca10077c","chunk-2d0da8f3":"f59eb4b6","chunk-a96a89e8":"7bfda370","chunk-be2390e8":"7e846b95","chunk-3eec9ae8":"e36d2c89","chunk-a177d904":"e8ccf4ee","chunk-e7e866dc":"6ab3608d","chunk-d711c7c2":"1c8a7361","chunk-f0a69470":"2f4a8550","chunk-911b1d48":"e555d265","chunk-f1add85e":"ae728742","chunk-c25eaef6":"5070a671","chunk-2ca0ce82":"cc339a87","chunk-cb86bbf4":"dfef2c17","chunk-cfbb9a80":"e964bea8","chunk-ecae3330":"35106269","chunk-2d0b9654":"292c6839","chunk-8de4cfb4":"4f23d65e","chunk-f53aa222":"a19226c8","stencil-polyfills-css-shim~2f793e75":"ae469b59","stencil-polyfills-dom~78119a74":"5388fc0a","chunk-2d0c9189":"4312ce11","chunk-2d0cf391":"1c4b4848","chunk-2d2248b6":"5252c7d3","chunk-2d22523a":"c0744dc4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-06f92ac4":1,"chunk-0d8f1b98":1,"chunk-0f261a1e":1,"chunk-14a192cf":1,"chunk-3a332b10":1,"chunk-50d2440c":1,"chunk-5ad11dd9":1,"chunk-79479038":1,"chunk-79db9216":1,"chunk-7aa6f11c":1,"chunk-be2390e8":1,"chunk-3eec9ae8":1,"chunk-a177d904":1,"chunk-e7e866dc":1,"chunk-d711c7c2":1,"chunk-f0a69470":1,"chunk-911b1d48":1,"chunk-f1add85e":1,"chunk-cfbb9a80":1,"chunk-ecae3330":1,"chunk-8de4cfb4":1,"chunk-f53aa222":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"stencil-polyfills-css-shim~2f793e75":"stencil-polyfills-css-shim~2f793e75","stencil-polyfills-dom~78119a74":"stencil-polyfills-dom~78119a74"}[chunkId]||chunkId) + "." + {"chunk-06f92ac4":"8bf8fbbd","chunk-09407743":"31d6cfe0","chunk-0d8f1b98":"bb88fa50","chunk-0f261a1e":"120d34d0","chunk-14a192cf":"c2551d5a","chunk-24573624":"31d6cfe0","chunk-2d0ac931":"31d6cfe0","chunk-2d0b8b30":"31d6cfe0","chunk-2d0be2dc":"31d6cfe0","chunk-2d0c0644":"31d6cfe0","chunk-2d0c211b":"31d6cfe0","chunk-2d0c4aa3":"31d6cfe0","chunk-2d0c8871":"31d6cfe0","chunk-2d0ceeba":"31d6cfe0","chunk-2d0cf315":"31d6cfe0","chunk-2d0d3c84":"31d6cfe0","chunk-2d0d6d65":"31d6cfe0","chunk-2d0d7863":"31d6cfe0","chunk-2d0d78b2":"31d6cfe0","chunk-2d0e9381":"31d6cfe0","chunk-2d0e9b48":"31d6cfe0","chunk-2d0f0b83":"31d6cfe0","chunk-2d2080c7":"31d6cfe0","chunk-2d217def":"31d6cfe0","chunk-2d21a9aa":"31d6cfe0","chunk-2d21d677":"31d6cfe0","chunk-2d21e70e":"31d6cfe0","chunk-2d221f74":"31d6cfe0","chunk-2d222cca":"31d6cfe0","chunk-2d2248a4":"31d6cfe0","chunk-2d224c2b":"31d6cfe0","chunk-2d22895d":"31d6cfe0","chunk-2d2304d2":"31d6cfe0","chunk-2d23721e":"31d6cfe0","chunk-383ab6b7":"31d6cfe0","chunk-3a332b10":"e464c740","chunk-4a0edd2d":"31d6cfe0","chunk-50d2440c":"0a99dc40","chunk-538ff868":"31d6cfe0","chunk-5ad11dd9":"f9a583e0","chunk-62f92ab4":"31d6cfe0","chunk-66eb9fb7":"31d6cfe0","chunk-6ac3eb20":"31d6cfe0","chunk-79479038":"99fe1539","chunk-79db9216":"e204bf24","chunk-7aa6f11c":"eddf6935","chunk-2d0da8f3":"31d6cfe0","chunk-a96a89e8":"31d6cfe0","chunk-be2390e8":"ddce7a51","chunk-3eec9ae8":"082e76e6","chunk-a177d904":"058cc869","chunk-e7e866dc":"acc1f30b","chunk-d711c7c2":"cb353844","chunk-f0a69470":"58ea16a7","chunk-911b1d48":"04aee94f","chunk-f1add85e":"b89cc5bc","chunk-c25eaef6":"31d6cfe0","chunk-2ca0ce82":"31d6cfe0","chunk-cb86bbf4":"31d6cfe0","chunk-cfbb9a80":"63744345","chunk-ecae3330":"daaa4619","chunk-2d0b9654":"31d6cfe0","chunk-8de4cfb4":"bca00e15","chunk-f53aa222":"8fe24c1e","stencil-polyfills-css-shim~2f793e75":"31d6cfe0","stencil-polyfills-dom~78119a74":"31d6cfe0","chunk-2d0c9189":"31d6cfe0","chunk-2d0cf391":"31d6cfe0","chunk-2d2248b6":"31d6cfe0","chunk-2d22523a":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([2,"chunk-vendors~253ae210","chunk-vendors~0f485567","chunk-vendors~14b916ce","chunk-vendors~3e8a68cc","chunk-vendors~0b523a52","chunk-vendors~14df5a6e","chunk-vendors~c7bac266","chunk-vendors~ee46407b","chunk-vendors~f9340652","chunk-vendors~b0d8a0ee","chunk-vendors~6b5437c6","chunk-vendors~26ec6776","chunk-vendors~c1c88ebd","chunk-vendors~a7772421","chunk-vendors~2a3b441f","chunk-vendors~8563996c","chunk-vendors~3cdc15ba","chunk-vendors~3202577f","chunk-vendors~e6881289","chunk-vendors~4e1a1682","chunk-vendors~96c1018a","chunk-vendors~2a4ed64f","chunk-vendors~4f47653e","chunk-vendors~cd55a14d","chunk-vendors~ad198ca0","chunk-vendors~ee7847b3","chunk-vendors~7f3f6916","chunk-vendors~5ea1a303","chunk-vendors~2a42e354","chunk-vendors~7274e1de","chunk-vendors~987e6011","chunk-vendors~db300d2f","chunk-vendors~2f426a33","chunk-vendors~4d01349d","chunk-vendors~3933242a","chunk-vendors~724d3aa1","chunk-vendors~399b027d","chunk-vendors~e258e298","chunk-vendors~8eeb4602","chunk-vendors~7db804d5","chunk-vendors~15f0789d","chunk-vendors~cc99a214","chunk-vendors~69ddfae0","chunk-vendors~24df2e00","chunk-vendors~2e6f40e9","chunk-vendors~6317f0e8","chunk-vendors~678f84af","chunk-vendors~ec8c427e","chunk-vendors~cfbf0a2e","chunk-vendors~aa596274","app~748942c6","app~ef35de0b","app~48138aff","app~3d9b8e9e","app~ea1f58e8"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
